import { render, staticRenderFns } from "./mobile-sheet.vue?vue&type=template&id=21e0b285&scoped=true&"
import script from "./mobile-sheet.vue?vue&type=script&lang=ts&"
export * from "./mobile-sheet.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-sheet.vue?vue&type=style&index=0&id=21e0b285&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0b285",
  null
  
)

export default component.exports